import { CALL_API } from '../../../middleware/api';
import * as ActionTypes from '../index';
var fetchPlastic = function (gamblerId) {
    var _a;
    return (_a = {
            type: ActionTypes.FETCH_CARDS
        },
        _a[CALL_API] = {
            endpoint: "/plastic/list?gamblerId=".concat(gamblerId),
            method: 'get',
            types: [ActionTypes.SUCCESS_FETCH_CARDS, ActionTypes.FAILURE_FETCH_CARDS],
            credentials: true
        },
        _a);
};
export function getPlastic(gamblerId) {
    return function (dispatch) {
        return dispatch(fetchPlastic(gamblerId));
    };
}



// WEBPACK FOOTER //
// ./src/actions/plastic/creators/index.js